import { Button, Card, Col, ListGroup, ListGroupItem, Row } from "react-bootstrap"
import ConsumptionByCourseViewModel from '../../domain/models/report/ConsumptionByCourseViewModel'
import PaginatedSearchResult from "../../domain/util/PaginatedSearchResult"
import { StyledPagedSearchButtonList, CreatorCourseListComponentStyles } from "./styles"

interface ReportByCourseListComponentProps{
    consumptionByCourseListViewPaginatedSearch:PaginatedSearchResult<ConsumptionByCourseViewModel>
    isLoading:boolean
    getConsumptionByCourse:(pageNumber:number) => void
}

const ReportByCourseListComponent = (
    {
        getConsumptionByCourse, 
        isLoading,
        consumptionByCourseListViewPaginatedSearch
    }:ReportByCourseListComponentProps) => {    

    const {
        currentPage,
        totalPages,
        hasPrevious,
        hasNext,
        totalRecords
    } = consumptionByCourseListViewPaginatedSearch

    const RenderPageButtons = ():JSX.Element =>{
        

        const lowPageLimit = currentPage > 2? currentPage - 2 : (currentPage === 2? currentPage - 1 : 1)
        const highPageLimit = currentPage < totalPages - 2? currentPage + 2 : (currentPage === totalPages - 1? currentPage + 1 : totalPages)

        let buttons:JSX.Element[] = []


        for(let i=lowPageLimit; i < highPageLimit+1 ; i++){
            buttons.push(
                <ListGroup.Item>
                    <Button className={"my-auto "+(currentPage === i?"active":"")} onClick={() => getConsumptionByCourse(i)}>
                        <p>{i}</p>
                    </Button>
                </ListGroup.Item>
            )
        }


        return(
            <StyledPagedSearchButtonList horizontal>
                <ListGroup.Item>
                    <Button disabled={!hasPrevious} onClick={() => getConsumptionByCourse(1)}>
                        <i className="bi bi-chevron-bar-left"/>
                    </Button>
                </ListGroup.Item>
                {
                    currentPage > 5 &&
                    <ListGroup.Item>
                        <Button onClick={() => getConsumptionByCourse(currentPage-5)}>
                            <p>
                                -5
                            </p>
                        </Button>
                    </ListGroup.Item>
                }
                <ListGroup.Item>
                    <Button disabled={!hasPrevious} onClick={() => getConsumptionByCourse(currentPage-1)}>
                        <i className="bi bi-chevron-left"/>
                    </Button>
                </ListGroup.Item>
                {buttons}
                <ListGroup.Item>
                    <Button disabled={!hasNext} onClick={() => getConsumptionByCourse(currentPage+1)}>
                        <i className="bi bi-chevron-right"/>
                    </Button>
                </ListGroup.Item>
                {
                    totalPages - currentPage > 4 &&
                    <ListGroup.Item>
                        <Button onClick={() => getConsumptionByCourse(currentPage+5)}>
                            <p>
                                +5
                            </p>
                        </Button>
                    </ListGroup.Item>
                }
                <ListGroup.Item>
                    <Button disabled={!hasNext} onClick={() => getConsumptionByCourse(totalPages)}>
                        <i className="bi bi-chevron-bar-right"/>
                    </Button>
                </ListGroup.Item>
            </StyledPagedSearchButtonList>)
    }

    const RenderLoadging = () : JSX.Element => {
        return (<>
            <Row className="mt-5 empty-result">
                <Col md="auto" className="ml-auto">
                    <img className="mr-3" src={"/img/student/home/woman-waiting.svg"} />
                </Col>
                <Col md="auto" className="my-auto mr-auto">
                    <Row>
                        <Col>
                            <h1>
                                Carregando dados...
                            </h1>
                        </Col>
                    </Row>
                    
                </Col>
            </Row>
        </>)
    }

    const RenderNoResult = () : JSX.Element => {
        return (<>
            <Row className="mt-5 empty-result">
                <Col md="auto" className="ml-auto">
                    <img className="mr-3" src={"/img/student/home/woman-waiting.svg"} />
                </Col>
                <Col md="auto" className="my-auto mr-auto">
                    <Row>
                        <Col>
                            <h1>
                                Nenhum registro
                            </h1>
                        </Col>
                    </Row>
                    
                </Col>
            </Row>
        </>)
    }

    const RenderResultTable = () : JSX.Element => {

        return (<>
            {totalRecords > 0
                ? (<>                       
                    <Row className="mt-2">
                        <Col md={6}>
                            <p className="pl-3">
                                Título do curso
                            </p>
                        </Col>
                        <Col md={2}>
                            <p className="pl-3">
                                Curso status
                            </p>
                        </Col>
                        <Col md={2}>
                            <p>
                                Pessoas cursando
                            </p>
                        </Col>
                        <Col md={2}>
                            <p>
                                Pessoas finalizadas
                            </p>
                        </Col>                                
                    </Row>
                    <Row className={isLoading?"d-none":""}>
                        <Col>
                            <ListGroup className="w-100 px-0">
                            {
                                consumptionByCourseListViewPaginatedSearch.items.map(item =>{
                                    return (
                                        <ListGroupItem className="px-0 py-2">
                                            <Card>
                                                <Card.Body className="py-2">
                                                    <Row>
                                                        <Col md={6} className="my-auto">
                                                            <p>{item.courseTitle}</p>
                                                        </Col>  
                                                        <Col md={2} className="my-auto">
                                                            <p>{item.courseStatus}</p>
                                                        </Col>                                                                        
                                                        <Col md={2} className="my-auto">
                                                            <p>{item.qtyApprenticeInProgress}</p>
                                                        </Col>
                                                        <Col md={2} className="my-auto">
                                                            <p>{item.qtyApprenticeDone}</p>
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </ListGroupItem>
                                    )
                                })
                            }
                            </ListGroup>
                        </Col>
                    </Row>
                    {
                        totalPages > 1 &&
                        <Row className={isLoading?"d-none":""}>
                            <Col md={"auto"} className="mx-auto my-4">
                                <RenderPageButtons/>
                            </Col>
                        </Row>
                    }
                </>)
                : (RenderNoResult())
            }
        </>)
    }

    return(
        <CreatorCourseListComponentStyles className="ml-3">            
            {isLoading ? 
                (RenderLoadging())
                : (RenderResultTable())
            }
        </CreatorCourseListComponentStyles>
    )
}

export default ReportByCourseListComponent;